export { default } from './Tabs';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Tabs/index.js
// module id = 422
// module chunks = 121